// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.esign_styles_title__FA8TO {
  margin: 8px 0;
}

.esign_styles_chartsContainer__OrYHj {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -8px;
}

.esign_styles_chartsItem__ixK1C {
  position: relative;
  width: 100%;
  box-sizing: border-box;
  padding: 0 8px;
  margin: 8px 0;
}

.esign_styles_card__\\+99C- {
  overflow: hidden;
}

.esign_styles_card__\\+99C- h3 {
  padding: 8px 16px;
  font-weight: 700 !important;
}

.esign_styles_cardContent__e7pDJ {
  position: relative;
  height: 350px;
}

.esign_styles_smallCard__4-Lg2 {
  width: 33%;
  min-width: 300px;
  flex-grow: 1;
}

.esign_styles_mediumCard__io0c- {
  width: 50%;
  min-width: 300px;
  flex-grow: 1;
}

.esign_styles_bigCard__0nZI6 {
  width: 66%;
  min-width: 300px;
  flex-grow: 1;
}

.esign_styles_tableBlock__NkUuk {
  padding: 8px 8px 16px;
  overflow-x: auto;
}

.esign_styles_tableBlock__NkUuk::-webkit-scrollbar {
  width: 3px;
  height: 3px;
  border-radius: 3px;
}

.esign_styles_tableBlock__NkUuk::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background-color: rgb(0 0 0 / 80%);
}

.esign_styles_tableBlock__NkUuk::-webkit-scrollbar-track {
  border-radius: 3px;
  background-color: rgb(0 0 0 / 10%);
}

.esign_styles_statusBlock__V4lQD {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
}

.esign_styles_statusCircle__A4jpB {
  display: flex;
  width: 175px;
  height: 175px;
  align-items: center;
  justify-content: center;
  border: var(--color-light-red) 4px solid;
  border-radius: 50%;
  animation: esign_styles_fadeIn__k4To6 1s ease 0s 1 normal;
  background-color: var(--color-pop-red);
  color: var(--color-dark-red);
  text-align: center;
  text-transform: capitalize;
  transition: 0.3s;
}

.esign_styles_okStatusCircle__oe0et {
  border: var(--color-light-green) 4px solid;
  background-color: var(--color-pop-green);
  color: var(--color-dark-green);
}

.esign_styles_statusCircle__A4jpB:hover {
  border-width: 8px;
  opacity: 0.8;
}

.esign_styles_userCountBlock__nXd7e {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  animation: esign_styles_fadeIn__k4To6 1s ease 0s 1 normal;
  font-size: 56px;
  font-weight: 700;
}

.esign_styles_customCardTitle__r19qF {
  padding: 8px 16px;
  margin: 0;
  font-size: 20px;
  line-height: 1.35;
}

.esign_styles_customCardSubTitle__lo1Jd {
  font-size: 12px;
  font-weight: 500;
}

@keyframes esign_styles_fadeIn__k4To6 {
  0% {
    opacity: 0;
    transform: scale(0.6);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DashboardCharts/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,kBAAkB;EAClB,yDAAqC;EACrC,sCAAsC;EACtC,4BAA4B;EAC5B,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,yDAAqC;EACrC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF","sourcesContent":[".title {\n  margin: 8px 0;\n}\n\n.chartsContainer {\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0 -8px;\n}\n\n.chartsItem {\n  position: relative;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0 8px;\n  margin: 8px 0;\n}\n\n.card {\n  overflow: hidden;\n}\n\n.card h3 {\n  padding: 8px 16px;\n  font-weight: 700 !important;\n}\n\n.cardContent {\n  position: relative;\n  height: 350px;\n}\n\n.smallCard {\n  width: 33%;\n  min-width: 300px;\n  flex-grow: 1;\n}\n\n.mediumCard {\n  width: 50%;\n  min-width: 300px;\n  flex-grow: 1;\n}\n\n.bigCard {\n  width: 66%;\n  min-width: 300px;\n  flex-grow: 1;\n}\n\n.tableBlock {\n  padding: 8px 8px 16px;\n  overflow-x: auto;\n}\n\n.tableBlock::-webkit-scrollbar {\n  width: 3px;\n  height: 3px;\n  border-radius: 3px;\n}\n\n.tableBlock::-webkit-scrollbar-thumb {\n  border-radius: 3px;\n  background-color: rgb(0 0 0 / 80%);\n}\n\n.tableBlock::-webkit-scrollbar-track {\n  border-radius: 3px;\n  background-color: rgb(0 0 0 / 10%);\n}\n\n.statusBlock {\n  display: flex;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n}\n\n.statusCircle {\n  display: flex;\n  width: 175px;\n  height: 175px;\n  align-items: center;\n  justify-content: center;\n  border: var(--color-light-red) 4px solid;\n  border-radius: 50%;\n  animation: fadeIn 1s ease 0s 1 normal;\n  background-color: var(--color-pop-red);\n  color: var(--color-dark-red);\n  text-align: center;\n  text-transform: capitalize;\n  transition: 0.3s;\n}\n\n.okStatusCircle {\n  border: var(--color-light-green) 4px solid;\n  background-color: var(--color-pop-green);\n  color: var(--color-dark-green);\n}\n\n.statusCircle:hover {\n  border-width: 8px;\n  opacity: 0.8;\n}\n\n.userCountBlock {\n  display: flex;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n  animation: fadeIn 1s ease 0s 1 normal;\n  font-size: 56px;\n  font-weight: 700;\n}\n\n.customCardTitle {\n  padding: 8px 16px;\n  margin: 0;\n  font-size: 20px;\n  line-height: 1.35;\n}\n\n.customCardSubTitle {\n  font-size: 12px;\n  font-weight: 500;\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n    transform: scale(0.6);\n  }\n\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `esign_styles_title__FA8TO`,
	"chartsContainer": `esign_styles_chartsContainer__OrYHj`,
	"chartsItem": `esign_styles_chartsItem__ixK1C`,
	"card": `esign_styles_card__+99C-`,
	"cardContent": `esign_styles_cardContent__e7pDJ`,
	"smallCard": `esign_styles_smallCard__4-Lg2`,
	"mediumCard": `esign_styles_mediumCard__io0c-`,
	"bigCard": `esign_styles_bigCard__0nZI6`,
	"tableBlock": `esign_styles_tableBlock__NkUuk`,
	"statusBlock": `esign_styles_statusBlock__V4lQD`,
	"statusCircle": `esign_styles_statusCircle__A4jpB`,
	"fadeIn": `esign_styles_fadeIn__k4To6`,
	"okStatusCircle": `esign_styles_okStatusCircle__oe0et`,
	"userCountBlock": `esign_styles_userCountBlock__nXd7e`,
	"customCardTitle": `esign_styles_customCardTitle__r19qF`,
	"customCardSubTitle": `esign_styles_customCardSubTitle__lo1Jd`
};
export default ___CSS_LOADER_EXPORT___;
